module.exports = __webpack_public_path__ + "static/media/circle-minus.632a0856.svg";